// extracted by css-extract-rspack-plugin
export default {"root":"YandexIdUserBarItem_root__SojPo"};